import Dialog from "@material-ui/core/Dialog";
import Fade from "@material-ui/core/Fade";
import React from "react";
import CrossSvg from "../assets/icons/svg/cross";
import "./style.scss";
import { toastr } from "react-redux-toastr";
import { useDispatch, useSelector } from "react-redux";
import {
  RecurringModelCheck,
  SetSelectedBatchId,
} from "../app/redux/actions/index";
// eslint-disable-next-line react/prop-types
const MyModal = ({
  activeIndex,
  onClose,
  open,
  data,
  clossable = true,
  useFlex = true,
  className,
  children,
  stepper,
  fullWidth = false,
  PaperProps = {}
  
}) => {
  const SetRecurringCheck = useSelector(
    (state) => state.homeReducer.SetRecurringCheck,
  );

  const onModalClose = () => {
    onClose();
  };

  const dispatch = useDispatch();

  const onToastShow = () => {
    dispatch(RecurringModelCheck(true));
    // toastr.error("You can not close this modal until you complete your transaction.")
  };

  return (
    <Dialog
      className={`my-modal ${className}`}
      onClose={SetRecurringCheck === "show" ? onToastShow : onModalClose}
      open={open}
      PaperProps={PaperProps}
      fullWidth={fullWidth}
    >
      <Fade in={open}>
        <>
          <div
            className={
              activeIndex === 1 || activeIndex === undefined
                ? "modal-close-icon"
                : activeIndex === 0 || activeIndex === undefined
                ? "close-icon"
                : "modal-close-icon"
            }
          >
            <CrossSvg
              onClick={
                SetRecurringCheck === "show" ? onToastShow : onModalClose
              }
            />
          </div>
          <div
            className={`modal-child ${
              useFlex ? "d-flex align-items-center" : ""
            }`}
          >
            {children}
          </div>
        </>
      </Fade>
    </Dialog>
  );
};
export default MyModal;
